import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomPhoneInput from '../Utilities/CustomPhoneInput'
import { EditMarketerInfoVM } from '../../Structure/ViewModels/Marketer/EditMarketerInfoVM'

const EditMarketerInfo = (props:{id:string}) => {
    const [vm , setVm] = useState<{viewModel:EditMarketerInfoVM}>({viewModel: new EditMarketerInfoVM(props.id)})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getData()
    },[])
  return (
<Container>
        {
            control.Show(
        <Row>
            <h3 className='py-5 text-center'>انشاء حساب مسوق جديد</h3>
            <Row className='py-4 justify-content-center'>
                <Col lg={8} className='p-3'>
                    <div className='d-flex flex-column'>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-3'>اسم المسوق</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                            <div className=' my-auto'>
                                <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.Data.name} onChange={a=>control.Name = a.target.value} />
                            </div>
                            </Col>
                        </Row> 
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>الايميل (اختياري)</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.Data.email||''} onChange={a=>control.Email = a.target.value} />
                                </div>
                            </Col>
                        </Row>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>الموبايل</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <CustomPhoneInput className='input-field' countryKey={control.Data.dial_code} setCountryKey={a=>control.DialCode=a} value={control.Data.mobile} setNumber={a=>control.Mobile =a}  placeholder='الموبايل...' />    
                                </div>
                            </Col>
                        </Row>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>الحساب البنكي (اختياري)</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.Data.bank_account||''} onChange={a=>control.BankAccount = a.target.value} />
                                </div>
                            </Col>
                        </Row>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>النسبة </label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.Data.commission} onChange={a=>control.Commission = a.target.value} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <div className='d-flex justify-content-center'>
                <button className='button-I btn-cl-I px-5 py-2 fw-bold' onClick={()=>control.send()}>اضافة</button>
            </div>
        </Row>
        )
    }
    </Container>
  )
}

export default EditMarketerInfo
